<template>
  <div class="login">
    <div class="login-card">
      <h1 class="text-center">台虎酒桶管理系統</h1>
      <div class="logo-img">
        <img :src="require('@/assets/imgs/login/LOGO.png')" alt="">
      </div>
      <b-card class="" bg-variant="light" text-variant="dark" v-if="step === 0">
        <b-card-body>
          <p>
            此為台虎開發中的酒桶管理系統，僅供公司內部管理使用。一般使用者請勿嘗試登入。
          </p>
          <div class="text-center">
            <b-button variant="primary" @click="step = 1">
              我明白了
            </b-button>
          </div>
        </b-card-body>
      </b-card>
      <div class="step-card" v-if="step === 1">
        <h3>請選擇身份</h3>
        <b-form-select v-model="selectedUser" :options="userOpts" class="w-100 mb-4"></b-form-select>
        <b-input type="text" v-model="manualInputUserName" class="mb-4 py-4 px-3" v-if="selectedUser === ''" placeholder="手動輸入信箱"></b-input>

        <b-button class="w-100" variant="primary" @click="nextStepClicked">下一步</b-button>
      </div>

      <div class="step-card" v-if="step === 2">
        <h3>請輸入密碼</h3>
        <b-input disabled :value="selectingUserName" class="mb-3"></b-input>
        <b-input type="password" v-model="inputPassword" class="mb-4"></b-input>
        <b-button class="w-100" variant="primary" @click="loginBtnClicked">登入</b-button>
        <a href="#" class="last-step-btn" @click.prevent="prevStepClicked"><b-icon icon="arrow-left"></b-icon></a>
      </div>
    </div>
    <div class="copyright">
      Copyright © 2025 臺虎精釀 Taihu Brewing. All rights reserved.
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      step: 0,
      selectedUser: 'fude@taihubrewing.com',
      manualInputUserName: '',
      userList: [
        {
          name: 'FUDE',
          id: 'fude@taihubrewing.com'
        },
        {
          name: 'LAB',
          id: 'lab@taihubrewing.com'
        },
        {
          name: 'LOGISTICS',
          id: 'logistics@taihubrewing.com'
        },
        {
          name: '管理員',
          id: 'admin@test.com'
        },
        {
          name: '手動輸入',
          id: '',
        }
      ],
      inputPassword: '',

      LOGIN_BUSY: 'LOGIN_BUSY',
    };
  },
  mounted() {
    // const hasToken = this.$store.getters['auth/hasToken'];
    // if (hasToken) {
    //   this.$router.push({
    //     name: 'EditMainScreen'
    //   });
    // }
  },
  computed: {
    isUsingManualInput() {
      return this.selectedUser === '';
    },
    userOpts() {
      return this.userList.map((user) => {
        return {
          text: user.name,
          value: user.id,
        }
      });
    },
    selectingUserName() {
      if (this.isUsingManualInput) {
        return this.manualInputUserName;
      }
      const user = this.userList.find((u) => {
        return u.id === this.selectedUser;
      });
      if (user) {
        return user.name;
      } else {
        return 'Unknown';
      }
    },
    loginBtnDisabled() {
      return this.email.length === 0 || this.password.length === 0;
    }
  },
  components: {
  },
  methods: {
    nextStepClicked() {
      if (this.isUsingManualInput && this.manualInputUserName.trim().length === 0) {
        alert('請輸入使用者信箱');
        return;
      }
      this.step += 1;
    },
    loginClicked() {

    },
    prevStepClicked() {
      this.step -= 1;
    },
    async loginBtnClicked() {
      this.$store.dispatch('appendComponentBusy', this.LOGIN_BUSY);
      try {
        const email = this.isUsingManualInput ? this.manualInputUserName : this.selectedUser;
        const logInRes = await this.$store.dispatch('api/postLoginPromise', {
          email: email,
          password: this.inputPassword,
        });
        await this.$store.dispatch('auth/loggedIn', logInRes.token);

        const infoRes = await this.$store.dispatch('api/getAccountInfoPromise');
        await this.$store.dispatch('auth/updateUser', infoRes);

        // this.error = false;
        this.$router.push({
          name: 'Dashboard'
        });
      } catch (error) {
        this.error = true;
        this.$store.dispatch('showMsg', error.toString());
      } finally {
        this.$store.dispatch('clearComponentBusy', this.LOGIN_BUSY);
      }
    },
  },

}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

.login {
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 3rem;

  .login-card {
    color: $color-primary;
    max-width: 480px;
    padding: 40px 40px 76px 40px;
    flex: 0 1 480px;

    .logo-img {
      text-align: center;
      >img {
        width: 200px;
      }
    }

    h2 {
      font-size: 1.5rem;
      font-weight: 800;
      text-align: center;
    }

    .step-card {
      position: relative;

      h3 {
        font-size: 1.25rem;
        font-weight: 400;
        text-align: center;
      }

      .last-step-btn {
        color: #000;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .copyright {
    position: absolute;
    bottom: 0;
    padding: 1rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: .8rem;
  }
}
</style>
